/** Single source of truth for LayoutSQV2 allowed and controlled components. */

export const ALLOWED_CHILD_COMPONENT_NAMES = [
	'HeaderV2',
	'StatusPill',
	'Form',
	'SingleForm',
	'BragBarV2',
	'CalloutBox',
	'CopyAndImage',
	'ThreeColumn',
	'Accordion',
	'CtaSection',
	'IconList',
	'ListAndImage',
	'Listicle',
	'MiniSplash',
	'BulletedImageList',
	'TextBragBar',
];

export const CONTROLLED_COMPONENT_NAMES = [
	'HeaderV2',
	'StatusPill',
	'Form',
	'SingleForm',
	'BragBarV2',
	'CalloutBox',
];
